// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ErrorBoundary__fallback___2KU5r{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.ErrorBoundary__fallbackWrapper___1-oKF{height:100%;position:relative}.ErrorBoundary__fallbackMsg___KzsyN{text-align:center;font-size:14px;margin-bottom:12px}.ErrorBoundary__fallbackButton___2E2OZ{margin:0 auto}\n", ""]);
// Exports
exports.locals = {
	"fallback": "ErrorBoundary__fallback___2KU5r",
	"fallbackWrapper": "ErrorBoundary__fallbackWrapper___1-oKF",
	"fallbackMsg": "ErrorBoundary__fallbackMsg___KzsyN",
	"fallbackButton": "ErrorBoundary__fallbackButton___2E2OZ"
};
module.exports = exports;
